import React from 'react';
export function ContentShowcaseSlide() {
  const videoThumbnails = [{
    title: 'Playa Linda',
    thumbnail: 'https://images.unsplash.com/photo-1590523741831-ab7e8b8f9c7f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    duration: '00:30'
  }, {
    title: 'Holiday Inn Aruba',
    thumbnail: 'https://images.unsplash.com/photo-1590001155093-a3c66ab0c3ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    duration: '00:20'
  }, {
    title: 'Holiday Inn Time Lapse',
    thumbnail: 'https://images.unsplash.com/photo-1590622783586-e95526e3a8bd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    duration: '00:30'
  }];
  return <div className="w-full bg-white" data-id="element-685">
      <div className="max-w-5xl mx-auto" data-id="element-686">
        <div className="flex flex-col md:flex-row gap-8 items-center mb-12" data-id="element-687">
          <div className="w-full md:w-1/3" data-id="element-688">
            <div className="w-32 h-32 rounded-full overflow-hidden mx-auto md:mx-0" data-id="element-689">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t9AcqBTZc97z7oLWTJi33G/unnamed_%284%29.png" alt="Fran" className="w-full h-full object-cover" data-id="element-690" />
            </div>
          </div>
          <div className="w-full md:w-2/3" data-id="element-691">
            <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-692">
              Ayudo a marcas de hospitalidad y turismo a destacarse con videos
              impactantes, tours virtuales inmersivos, contenido aéreo y
              anuncios inteligentes. No soy un influencer, soy un narrador que
              hace que los lugares sean imposibles de ignorar.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-693">
          {videoThumbnails.map((video, index) => <div key={index} className="bg-gray-50 rounded-lg overflow-hidden" data-id="element-694">
              <div className="aspect-[9/16] relative" data-id="element-695">
                <img src={video.thumbnail} alt={video.title} className="w-full h-full object-cover" data-id="element-696" />
                <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-white" data-id="element-697">
                  <p className="text-white" data-id="element-698">{video.title}</p>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/50 text-white text-xs px-2 py-1 rounded" data-id="element-699">
                  {video.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center" data-id="element-700">
                  <div className="w-12 h-12 rounded-full bg-black/50 flex items-center justify-center" data-id="element-701">
                    <div className="w-0 h-0 border-t-[8px] border-t-transparent border-l-[16px] border-l-white border-b-[8px] border-b-transparent ml-1" data-id="element-702"></div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="flex justify-center" data-id="element-703">
          <a href="https://www.instagram.com/explorandoconfran" target="_blank" rel="noopener noreferrer" className="bg-black text-white px-8 py-3 text-sm uppercase hover:bg-gray-800 transition-colors rounded" data-id="element-704">
            @explorandoconfran
          </a>
        </div>
      </div>
    </div>;
}